goog.provide("shadow.js.shim.module$$mui$material$Paper$default");
shadow.js.shim.module$$mui$material$Paper$default = shadow.js.shim.module$$mui$material$Paper.default;
